export function generateRegistrationNumber() {
    // e.g. ZA25-582-9511
    const rand = () =>
      Math.floor(1000 + Math.random() * 9000)
        .toString()
        .slice(-4);
    return `ZA${rand().slice(0, 2)}-${rand()}-${rand()}`;
  }